module.exports = __webpack_public_path__ + "img/wechat.fc148108.svg";